<template>
  <div>
    <div
      v-for="(item, index) in additionalData"
      :key="`addition_${index}`">
      <div class="basic-second-title"><i/><em>{{ item.upload_position }}</em></div>
      <div
        class="noCycle-main clearfix"
        v-loading.body="loading">
        <el-checkbox-group
          v-model="checkList"
          class="clearfix"
        >
          <div
            v-for="(itemA, indexA) in item.upload_list"
            :key="indexA"
            @mouseenter="toggleShow(itemA)"
            @mouseleave="toggleShow(itemA)"
          >
            <!--默认无 显示层 S-->
            <div
              class="cycle-cont"
              v-show="itemA.isCycleHoverChoose"
              :class="itemA.file_list && itemA.file_list.length >0 ? 'cycle-confirmed' : ''"
            > <!--  加class cycle-confirmed 有材料已确认增加蓝色背景 无材料则不增加class-->
              <template v-if="itemA.astatus === 1">
                <div class="confirmed">已确认</div>
              </template>
              <div class="cycle-ico"/>
              <div>{{ itemA.file_name }}</div>
            </div>
            <!--默认无 显示层 E-->

            <!--遮罩层 选择按钮后 S-->
            <div
              class="cycle-mask"
              v-show="additionalSub.isCycleChoose">
              <el-checkbox
                @change="setList(itemA.yun_id, itemA.id)"
                :label="`${itemA.yun_id}_${itemA.id}`"
                :key="itemA.id">{{ itemA.file_name }}</el-checkbox>
            </div>
            <!--遮罩层 选择按钮后 E-->

            <!--鼠标放上 出现 S-->
            <div
              class="cycle-hover clearfix"
              v-show="itemA.isCycleHover">
              <div>
                <el-button
                  type="primary"
                  size="small"
                  @click="setPreview(itemA.id, itemA.file_list[0])"
                  :disabled="itemA.file_list.length === 0"
                >预览</el-button>
              </div>
              <div>
                <el-button
                  type="primary"
                  size="small"
                  @click="downloadFile(itemA)"
                  :disabled="itemA.file_list && itemA.file_list.length === 0"
                >下载</el-button>
              </div>
            </div>
            <!--鼠标放上 出现 E-->
            <!--走马灯 预览展示 start-->
            <img
              v-show="false"
              ref="vueimg"
              v-img="{ group: `group_${itemA.yun_id}_${itemA.id}` }"
              v-for="itemFile in itemA.file_list"
              :key="itemFile"
              :src="itemFile | imgHome">
          <!--走马灯 预览展示 end-->
          </div>
        </el-checkbox-group>
      </div>
    </div>
    <div
      class="rotate-area left-rotate"
      @click="rotateClick(-90)"/>
    <div
      class="rotate-area right-rotate"
      @click="rotateClick(90)"/>
      <!-- <div class="rotate-area save-rotate" @click="saveRotate"></div>
    <div class="rotate-area del-rotate" @click="delRotate"></div>-->
  </div>
</template>
<script>
import Vue from 'vue';
import VueImg from '@/plugins/v-img';
import { jmUploadFile } from '@/components/tool';
import tableCheckbox from '@/components/tool/tableCheckbox';
import { getBinaryContent } from 'jszip-utils';
import JSZip from 'jszip';
import NProgress from 'nprogress';

Vue.use(VueImg);
export default {
  props: {
    additionalData: {
      type: Array,
      default() {
        return {};
      },
    },
    additionalSub: {
      type: Object,
      default() {
        return {};
      },
    },
    allchecked: {
      type: Boolean,
      default: false
    },
    uploadList: {
      type: Object,
      default() {
        return {};
      },
      required: false
    },
    primordialList: {
      type: Array,
      default() {
        return [];
      },
      required: false
    },
    originDataList: {
      type: Array,
      default() {
        return {};
      },
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      loading: false, // Loading
      checkAll: false,
      checkList: [],
    };
  },
  mounted() {
    this.checkList = this.originDataList;
    let isAll = this.originDataList.length === this.primordialList.length; // 是否为全选状态
    this.$emit(
      'update:allchecked',
      isAll
    );
    let is = this.originDataList.length > 0 &&
        this.originDataList.length < this.primordialList.length; // 全选框显示内容
    this.$emit(
      'update:indeterminate',
      is
    );
  },
  methods: {
    /*
       * 单选后判断是否为全选
       * */
    setList(position, id) {
      if (this.uploadList[position].indexOf(id) === -1) {
        this.uploadList[position].push(id);
        let childList = this.uploadList;
        this.$emit(
          'update:uploadList',
          childList
        );
        this.originDataList.push(`${position}_${id}`);
        let hascheck = this.originDataList;
        this.$emit(
          'update:originDataList',
          hascheck
        );
      } else {
        this.uploadList[position] = this.uploadList[position].filter((item) => {
          return (item !== id);
        });
        let childList = this.uploadList;
        this.$emit(
          'update:uploadList',
          childList
        );
        let upcheck = this.originDataList.filter((item) => {
          return (item !== `${position}_${id}`);
        });
        this.$emit(
          'update:originDataList',
          upcheck
        );
      }
    },
    /*
       * 设置 hover 隐藏显示
       * */
    toggleShow (item) {
      if (this.additionalSub.isCyCLeChooseMask) {
        item.isCycleHoverChoose = !item.isCycleHoverChoose;
        item.isCycleHover = !item.isCycleHover;
      }
    },
    /*
       * 预览云盘材料
       * */
    setPreview (id, url) {
      this.additionalData.forEach((item) => {
        item.upload_list.forEach((subItem) => {
          if (subItem.file_list.length > 0) {
            if (subItem.id === id) {
              this.$nextTick(() => {
                document.querySelectorAll(`[data-vue-img-group=group_${subItem.yun_id}_${subItem.id}]`)[0].click();
                if (this.checkImg(url) === 1) {
                  this.$el.querySelectorAll('.rotate-area').forEach((item) => {
                    item.style.display = 'block';
                  });
                }
              });
            }
          }
        });
      });
    },
    checkImg(url) {
      let isImg = ['bmp', 'jpg', 'jpeg', 'png', 'gif'];
      let strTemp = url.split('.');
      let strCheck = strTemp[strTemp.length - 1];
      let result = 0;
      if (this.isInArray(isImg, strCheck)) {
        result = 1;
      } else {
        result = 2;
      }
      return result;
    },
    isInArray(arr, value) {
      for (let i = 0; i < arr.length; i++) {
        if (value === arr[i]) {
          return true;
        }
      }
      return false;
    },
    /*
       * 云盘材料图片旋转
       * */
    rotateClick(angle) {
      window.vueImg.rotate(angle);
    },
    /*
      * 下载
      * */
    onlyDown(yun, id) {
      let only = Object.create({});
      this.$set(only, yun, [id]);
      this.$http._post({
        url: '/index/apply_file/downloadFile',
        data: { data_list: only, crm_id: this.$route.params.crmid }
      }).then((response) => {
        window.location.href = response.data;
      });
    },
    getFileName(url) {
      const parts = url.split('/');
      return parts[parts.length - 1];
    },
    downloadFile(item) {
      if (!item.file_list.length || item.file_list.length === 0) {
        this.$message.error('没有文件');
        return false;
      }
      const msg = this.$message({
        message: '下载中...',
        duration: 0,
        showClose: false,
      });
      NProgress.start();
      let currentProgress = 0;
      Promise.all(item.file_list.map((url) => {
        return getBinaryContent(
          Vue.filter('imgHome')(url, true),
          {
            progress: (p) => {
              if (p.percent === 100) {
                currentProgress += 100;
                NProgress.set(currentProgress / 100 / item.file_list.length);
              }
            }
          }
        );
      })).then((data) => {
        const zip = new JSZip();
        // zip.folder(item.file_name);
        data.forEach((buffer, index) => {
          zip.file(this.getFileName(item.file_list[index]), buffer, { binary: true });
        });
        zip.generateAsync({ type: 'blob' }).then((blob) => {
          this.$http.saveFile(blob, item.file_name);
          this.$message.success('下载成功！');
          msg.close();
        });
      }).catch(() => {
        this.$message.error('下载失败！');
        msg.close();
        NProgress.down(true);
      });
    }
  },
  watch: {
    originDataList(val) {
      this.checkList = val;
      if (val.length === 0) {
        let newlist = Object.create({});
        Object.keys(this.uploadList).forEach((item) => {
          this.$set(newlist, item, []);
        });
        this.$emit(
          'update:uploadList',
          newlist
        );
      }
      let isAll = this.originDataList.length === this.primordialList.length; // 是否为全选状态
      this.$emit(
        'update:allchecked',
        isAll
      );
      let is = this.originDataList.length > 0 &&
          this.originDataList.length < this.primordialList.length; // 全选框显示内容
      this.$emit(
        'update:indeterminate',
        is
      );
    },
  },
  components: {
    'jm-tableCheckBox': tableCheckbox, // 设置材料
    jmUploadFile,
  }
};
</script>
<style scoped>
  .noCycle-main > .el-checkbox-group > div{
    display: flex;
    position: relative;
    width: 160px;
    height: 112px;
    margin: 10px;
    padding: 6px;
    float: left;
    border: #b8c4ce dashed 1px;
    cursor: pointer;
  }
  .noCycle-main > .el-checkbox-group {
    font-size: 100%;
  }
  .cycle-cont{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
  }
  .cycle-ico{
    background: url("../../../src/assets/images/cycle-ico.png") no-repeat;
    display: block;
    width: 45px;
    height:45px;
    margin: 10px auto;
  }
  .cycle-confirmed .cycle-ico{
    background: url("../../../src/assets/images/cycle-ico1.png") no-repeat;
  }
  .cycle-confirmed{
    background: #3368fa;
    color: #fff;
  }
  .confirmed{
    position: absolute;
    right: 0px;
    top: 5px;
    padding: 2px 8px;
    background: #ffcd38;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    color: #424141;
    font-size: 12px;
  }
  .cycle-hover{
    width: 100%;
    display: flex;
    background: #f2f2f2;
    border: solid #e7e7e7 1px;
    align-items: center;
  }
  .cycle-hover > div{
    width: 50%;
    text-align: center;
  }
  .cycle-mask{
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    position: absolute;
    left: 0;
    top: 0;
  }
  .cycle-mask .el-checkbox{
    width: 100%;
    height: 100%;
    margin: 4px;
  }
  .left-rotate{
    position: fixed;
    bottom:20px;
    left:45%;
    width: 50px;
    height:50px;
    z-index: 1003;
    cursor: pointer;
    background: #fff url(../../../src/assets/images/icon-rotate-l.png) no-repeat center;
    opacity:0.8;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    border-radius: 5px;
    display: none;
  }
  .right-rotate{
    position: fixed;
    bottom:20px;
    left:49%;
    width: 50px;
    height:50px;
    z-index: 1003;
    cursor: pointer;
    background: #fff url(../../../src/assets/images/icon-rotate-r.png) no-repeat center;
    opacity:0.8;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    border-radius: 5px;
    display: none;
  }
  .save-rotate{
    position: fixed;
    bottom:20px;
    left:53%;
    width: 50px;
    height:50px;
    line-height:50px;
    background: #fff;
    z-index: 1003;
    color:#333;
    text-align: center;
    cursor: pointer;
    opacity:0.8;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    border-radius: 5px;
    font-size:15px;
    display: none;
  }
  .del-rotate{
    position: fixed;
    bottom:20px;
    left:57%;
    width: 50px;
    height:50px;
    line-height:50px;
    background: #fff;
    z-index: 1003;
    color:#333;
    text-align: center;
    cursor: pointer;
    opacity:0.8;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    border-radius: 5px;
    font-size:15px;
    display: none;
  }
  .left-rotate:hover,.right-rotate:hover,.save-rotate:hover.del-rotate:hover{
    opacity:1;
  }
  .save-rotate:after{
    content:"保存";
  }
  .del-rotate:after{
    content: "删除";
  }
  .content-v-img{
    text-align: center;
  }
  .content-v-img canvas {
    pointer-events: none;
  }
</style>`
